import React from 'react'
import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'

export const CardHeader = styled.div<{ padding?: string }>`
  width: 100%;
  border-bottom: 1px solid ${tokens.border.hairline};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: ${(props) => props.padding || 'var(--card-padding)'};
`

export const CardBody = styled.div<{ padding?: string }>`
  width: 100%;
  padding: ${(props) => props.padding || 'var(--card-padding)'};
`

export const StyckyFooter = styled.div`
  margin-top: 1rem;
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: var(--card-padding);
  z-index: 100;
  display: flex;
  justify-content: flex-end;
`

export const CardFooter = ({ children }: { children: React.ReactNode }) => {
  return <Box>{children}</Box>
}

export const Card = styled.div<{
  padding?: string
  borderLeft?: string
  height?: string
  mt?: string
  onClick?: () => void
  fullBorder?: string
  hoverBorder?: boolean
  noScale?: boolean
}>`
  width: 100%;
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  color: ${tokens.text.primary};

  --card-padding: ${(props) => props.padding || '1rem'};
  border-left: ${(props) => (props.borderLeft ? `4px solid ${props.borderLeft}` : `1px solid ${tokens.border.hairline}`)};
  height: ${(props) => props.height || 'auto'};
  margin-top: ${(props) => props.mt || '0'};
  position: relative;
  ${(props) => props.onClick && 'cursor: pointer;'};
  ${(props) => props.onClick && 'transition: all 0.2s ease;'};
  ${(props) => props.fullBorder && 'border: 1px solid ' + props.fullBorder};
  ${(props) => props.onClick && !props.noScale && '&:hover { scale: 1.01;}'};
  ${(props) =>
    !props.fullBorder &&
    props.hoverBorder &&
    'border: 1px solid ' + tokens.border.strong + ';'};
  ${(props) => props.hoverBorder && '&:hover { border: 1px solid ' + tokens.accent.base + ';'};
`
